import { create } from 'zustand'

export const useStore = create((set, get) => ({
  loading: true,
  isMobile: false,
  scrollPosition: 0,
  user: null,
  andreaAccess: false,
  andreaPassword: 'acherrmann1986',
}))
